import { batch, signal } from "@preact/signals-react"
import {
	alertsSection,
	isMinMaxPriceTabEmpty,
	isMinMaxPriceTabLoading,
	isNoAvailabilityTabEmpty,
	isNoAvailabilityTabLoading,
	isPriceChangeTabEmpty,
	isPriceChangeTabLoading,
	isPriceComparisonTabEmpty,
	isPriceComparisonTabLoading,
	isRatingTabEmpty,
	isRatingTabLoading
} from "Pages/ReportsAlerts/Alerts/@signals"
import { ALERTS } from "Pages/ReportsAlerts/Alerts/@constants"
import { offices, reports } from "@signals"


export const lastOfficeSubmitted = signal({ office: null, report: null })

const TAB_ORDER = [ALERTS.PRICE_COMPARISON, ALERTS.NO_AVAILABILITY, ALERTS.PRICE_CHANGE, ALERTS.MIN_MAX_PRICE, ALERTS.RATING]
const TAB_EMPTY_SIGNALS = {
	[ALERTS.PRICE_COMPARISON]: isPriceComparisonTabEmpty,
	[ALERTS.NO_AVAILABILITY]: isNoAvailabilityTabEmpty,
	[ALERTS.PRICE_CHANGE]: isPriceChangeTabEmpty,
	[ALERTS.MIN_MAX_PRICE]: isMinMaxPriceTabEmpty,
	[ALERTS.RATING]: isRatingTabEmpty,
}

export const clearSignals = () => batch(() => {
	lastOfficeSubmitted.value = { office: null, report: null }
})

export const setLastOfficeSubmitted = () => {
	if (!isPriceComparisonTabLoading.value
		&& !isPriceChangeTabLoading.value
		&& !isRatingTabLoading.value
		&& !isNoAvailabilityTabLoading.value
		&& !isMinMaxPriceTabLoading.value) {
		lastOfficeSubmitted.value = { office: offices.value, report: reports.value }

		if (TAB_EMPTY_SIGNALS[alertsSection.value]?.value) {
			const firstNonEmpty = TAB_ORDER.find(tab => !TAB_EMPTY_SIGNALS[tab].value)
			if (firstNonEmpty) alertsSection.value = firstNonEmpty
		}
	}
}